var importScriptsInstalledChunks = {5204: 1,};
// importScripts chunk loading
var importScriptsInstallChunk = (data) => {
    var [chunkIds, moreModules, runtime] = data;
    for (var moduleId in moreModules) {
        if (__webpack_require__.o(moreModules, moduleId)) {
            __webpack_require__.m[moduleId] = moreModules[moduleId];
        }
    }
    if (runtime) runtime(__webpack_require__);
    while (chunkIds.length) importScriptsInstalledChunks[chunkIds.pop()] = 1;
    importScriptsParentChunkLoadingFunction(data);
};

var importScriptsChunkLoadingGlobal = self["rspackChunkOwa"] = self["rspackChunkOwa"] || [];
var importScriptsParentChunkLoadingFunction = importScriptsChunkLoadingGlobal.push.bind(importScriptsChunkLoadingGlobal);
importScriptsChunkLoadingGlobal.push = importScriptsInstallChunk;
__webpack_require__.f.i = (chunkId, promises) => {
    
    // "1" is the signal for "already loaded
    if (!importScriptsInstalledChunks[chunkId]) {
        if (true) {
            
            importScripts(__webpack_require__.tu(__webpack_require__.p + __webpack_require__.u(chunkId)));
            
        }
    }
    
};
